module.exports = __webpack_public_path__ + "static/media/review_normal.1b1db82f.png";